// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  brand: 'toyota',
  env: 'dev',
  spaHost: 'https://asp.dev.dealer.toyota.com/',
  efcApi: 'https://asp-api.dev.dealer.toyota.com/catalog/proxy-external/efc/vehiclecontent/v1/',
  dcsb2oApi: 'https://asp-api.dev.dealer.toyota.com/catalog/proxy-external/dcs-b2o/',
  useEOSForDCS: true,
  xBrand: 'T',
  xClient: 'TO-WEB',
  xVersion: '1.0',
  aspAppointmentApi: 'https://asp-api.dev.dealer.toyota.com/appointment/api/',
  aspAvailabilityApi: 'https://asp-api.dev.dealer.toyota.com/availability/api/',
  aspEmployeeServiceApi: 'https://asp-api.dev.dealer.toyota.com/employee/api/',
  aspCatalogApi: 'https://asp-api.dev.dealer.toyota.com/catalog/api/',
  dealerDaily:'https://dev.dealer.toyota.com',
  digiChecklistApi: 'https://asp-api.dev.dealer.toyota.com/digital-checklist/',
  baseApi: 'https://asp-api.dev.dealer.toyota.com',
  showDelivery: true,
  dis: "https://admin.staging.dis.toyota.com/dealers/Toyota/",
  enableCorporateDashboard: true,
  enableParts: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.